import { Dispatch } from "react";
import { createSlice } from "@reduxjs/toolkit";
import type { PayloadAction } from "@reduxjs/toolkit";
import type { Amil } from "./api";
import { fetchAmilList } from "./api";

export interface ReportAmil {
  amil: string | null;
  amil_list: Amil[];
}

const initialState: ReportAmil = {
  amil: null,
  amil_list: [],
};

const amilStateSlice = createSlice({
  name: "amilState",
  initialState,
  reducers: {
    setAmil(state, action: PayloadAction<string | null>) {
      state.amil = action.payload;
    },
    setAmilList(state, action: PayloadAction<Amil[]>) {
      state.amil_list = action.payload;
    },
  },
});

export const { setAmil, setAmilList } = amilStateSlice.actions;

export const updateAmilList = (
  token: string,
  data?: { [key: string]: string }
) => async (dispatch: Dispatch<PayloadAction<Amil[]>>) => {
  try {
    let extras: { [key: string]: string } | undefined = undefined;

    if (data) {
      const { agency, start_date, end_date, kariah } = data;
      extras = {
        agency,
        start_date,
        end_date,
        kariah,
      };

      if (data.download) {
        extras["download"] = "1";
      }
    }

    const list = await fetchAmilList(extras)(token);
    dispatch(setAmilList(list));
  } catch (e) {
    console.log(e);
  }
};

export default amilStateSlice.reducer;
